import uiNewsCard from './card'
import uiNewsPreview from './preview'

export { uiNewsCard, uiNewsPreview }
